module.exports = __webpack_public_path__ + "img/BNDCR-C.47c9607f.png";